// extracted by mini-css-extract-plugin
export default {"root":"CheckoutSuccessfull_root__GXfqu"};